import { publicRoutes, pritiveRoutes } from '@/router'

export default {
  namespaced: true,
  state: {
    routes: []
  },
  mutations: {
    addRoutes(state, routes) {
      state.routes = [...publicRoutes, ...routes]
    }
  },
  actions: {
    // 根据权限筛选路由
    filterRoutes(context, menus) {
      const routes = []
      menus.forEach(key => {
        routes.push(...pritiveRoutes.filter(route => key === route.name))
      })
      // 404页面兜底
      routes.push({
        path: '/:catchAll(.*)',
        redirect: '/404'
      })
      // 将筛选出来的路由添加到仓库
      context.commit('addRoutes', routes)
      return routes
    }
  }
}
